import PropTypes from 'prop-types'
import {useCallback} from 'react'
import isEmpty from 'lodash/isEmpty.js'

import Row from '../../../../common/components/Form/Row.js'
import BaseReconcileForm from '../BaseReconcileForm.js'
import ReconcileSelect from '../ReconcileSelect.js'

export default function ReconcileForm({...props}) {
  const onChange = useCallback(
    (value, name) => props.updateColumnMapping(value, name),
    [],
  )

  if (isEmpty(props.columnsToDataMap)) {
    return null
  }

  return (
    <BaseReconcileForm className="medium-10" {...props}>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.sku}
          errorMessage={props.columnErrors.sku}
          name="sku"
          label="SKU"
          className="medium-10"
          onChange={onChange}
        />
      </Row>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.add_tag}
          errorMessage={props.columnErrors.add_tag}
          name="add_tag"
          label="Add Tag"
          className="medium-10"
          onChange={onChange}
        />
      </Row>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.remove_tag}
          errorMessage={props.columnErrors.remove_tag}
          name="remove_tag"
          label="Remove Tag"
          className="medium-10"
          onChange={onChange}
        />
      </Row>
    </BaseReconcileForm>
  )
}

ReconcileForm.propTypes = {
  columns: PropTypes.array.isRequired,
  columnsToDataMap: PropTypes.object.isRequired,
  columnErrors: PropTypes.object.isRequired,
  updateColumnMapping: PropTypes.func.isRequired,
}
